import { stores as vilStores } from './vil/index';
import { stores as uScopeStores } from './uScope/index';
import { stores as annotationsStores } from './annotations/index';
import { stores as iaStores } from './image-analysis/index';
import { stores as conferencingStores } from './conferencing/index';
import { stores as userStores } from './user/index';

export * from './core/Store';

export const stores = [
  ...vilStores,
  ...uScopeStores,
  ...annotationsStores,
  ...iaStores,
  ...conferencingStores,
  ...userStores
];



// WEBPACK FOOTER //
// ./src/shared/stores/index.js